

import "./CircularProgressBarCore/CircularProgressBarCore.st.css.js";
import "../Tooltip/Tooltip.st.css.js";
import "../Foundation/stylable/colors.st.css.js";
import "../Foundation/stylable/typography.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_211_0_CircularProgressBar";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_211_0_CircularProgressBar__root","progressBar":"wds_1_211_0_CircularProgressBar__progressBar","tooltip":"wds_1_211_0_CircularProgressBar__tooltip"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-font-family-default":"--wds-font-family-default","wds-font-size-100":"--wds-font-size-100","wds-font-weight-bold":"--wds-font-weight-bold","wds-font-line-height-200":"--wds-font-line-height-200"}; 




